/*©**********************************************************************************
*                                                                                   *
* SPDX-License-Identifier: AGPL-3.0-or-later                                        *
*                                                                                   *
* This program is licensed under the GNU Affero General Public License v3+.         *
* See the LICENSE file or <https://www.gnu.org/licenses/agpl-3.0.html> for details. *
*                                                                                   *
**********************************************************************************©*/

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@mantine/core/styles.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import reportWebVitals from './reportWebVitals';
import { MantineProvider } from '@mantine/core';
import { fetchRuntimeAppName } from './config/app';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

async function start(): Promise<void> {
  const appName = await fetchRuntimeAppName();
  document.title = appName;
  const descriptionTag = document.querySelector('meta[name="description"]');
  if (descriptionTag) {
    descriptionTag.setAttribute('content', `${appName} - Automated Trading Platform`);
  }

  root.render(
    <React.StrictMode>
      <MantineProvider>
        <Provider store={store}>
          <BrowserRouter basename="/">
            <App />
          </BrowserRouter>
        </Provider>
      </MantineProvider>
    </React.StrictMode>,
  );
}

void start();
reportWebVitals();
